import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getBulkOrderById } from "../../api/BulkorderService";

export default function BulkorderView() {
  const location = useLocation();
  const navigate = useNavigate();

  const id = location?.state?.bulkOrderId;

  const [bulkOrder, setBulkOrder] = useState(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  useEffect(() => {
    if (!id) {
      navigate("/bulk-order");
      return;
    }

    const load = async () => {
      try {
        const res = await getBulkOrderById(id);

     

        setBulkOrder(res?.data || res);
      } catch (err) {
      }
    };

    load();
  }, [id, navigate]);

  if (!bulkOrder) {
    return <h5 className="text-center mt-4">Loading...</h5>;
  }

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <h5 className="mb-3">View Bulk Order</h5>

      <div className="row">
          <div className="col-md-6">
            <b>Company Name : </b>
            {bulkOrder.companyName || "-"}
          </div>

          <div className="col-md-4">
            <b>Contact Person : </b>
            {bulkOrder.contactPerson || "-"}
          </div>
          <div className="col-10"></div>
          <div className="col-md-4">
            <b>Email : </b>
            {bulkOrder.email || "-"}
          </div>

          <div className="col-md-4">
            <b>Phone : </b>
            {bulkOrder.phoneNo || "-"}
          </div>

          <div className="col-md-4">
            <b>City : </b>
            {bulkOrder.city || "-"}
          </div>

          <div className="col-md-4">
            <b>Project Type : </b>
            {bulkOrder.projectType || "-"}
          </div>

          <div className="col-md-4">
            <b>Product Category : </b>
            {bulkOrder.productCategory || "-"}
          </div>

          <div className="col-md-4">
            <b>Quantity : </b>
            {bulkOrder.quantity || "-"}
          </div>

          <div className="col-md-4">
            <b>Required Delivery Date : </b>
            {formatDate(bulkOrder.requiredDeliveryDate)}
          </div>

          <div className="col-md-4">
            <b>Installation Needed : </b>
            {bulkOrder.isInstallationNeeded ? "Yes" : "No"}
          </div>

          <div className="col-md-4">
            <b>Agreed : </b>
            {bulkOrder.isAgreed ? "Yes" : "No"}
          </div>

          <div className="col-md-4">
            <b>Status : </b>
            <span
              className={`badge ${bulkOrder.status === "PENDING"
                  ? "bg-warning text-dark"
                  : "bg-success"
                }`}
            >
              {bulkOrder.status}
            </span>
          </div>

          <div className="col-md-12">
            <b>About Project : </b>
            {bulkOrder.aboutProject || "-"}
          </div>

          <div className="col-md-12">
            <b>Message : </b>
            {bulkOrder.message || "-"}
          </div>

          <div className="col-md-12">
            <b>Reference Design : </b>

            <div className="d-flex gap-3 flex-wrap mt-2">
              {bulkOrder.referenceDesign?.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  width={150}
                  height={150}
                  style={{
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}